import { ErrorModal } from "@/components/shared/modal/error-modal";
import Grid from "@material-ui/core/Grid";
import React, { useEffect, useState } from "react";
import { Outlet } from "react-router-dom";
import { useRootTypeContext } from "../rootTypes/context/RootTypeContext";
import { getRootTypes } from "../rootTypes/repositories/RootTypes";
import { TableLocations } from "./components/DataTable/TableLocations";
import { useLocationsContext } from "./context/Location";
import { useLocationTypesContext } from "./context/LocationType";
import { getLocations } from "./repositories/Location";
import { getLocationTypes } from "./repositories/LocationType";

export const LocationsPage = () => {
	const { state, actions } = useLocationsContext();
	const { actions: locationTypeActions } = useLocationTypesContext();
	const { actions: rootActions } = useRootTypeContext();

	const [isLoading, setIsLoading] = useState(true);
	const [fetchDataError, setFetchDataError] = useState<string | null>(null);

	const getLocationsFromAPI = async () => {
		setIsLoading(true);

		const values = await Promise.all([
			getLocations(),
			getLocationTypes(),
			getRootTypes(),
		])
			.then((r) => {
				const [
					{ ok: locationOk, locations },
					{ ok: locationTypeOk, locationTypes },
					{ ok: rootOk, rootTypes },
				] = r;

				if (locationOk && rootOk && locationTypeOk) {
					actions.setLocations(locations);
					locationTypeActions.setLocationTypes(locationTypes);
					rootActions.setRootTypes(rootTypes);
					setIsLoading(false);
				}
			})
			.catch((e) => {
				setFetchDataError(e);
			});
	};
	useEffect(() => {
		getLocationsFromAPI();
	}, []);

	if (state.locations) {
		return (
			<>
				<Grid container justifyContent="center" alignItems="center">
					<Grid item md={12} xs={12} style={{ margin: 0 }}>
						<div style={{ width: "100%", padding: "10px 0 20px" }}>
							<TableLocations
								isLoading={isLoading}
								getLocationsFromAPI={getLocationsFromAPI}
							/>
						</div>
						<Outlet />
					</Grid>
				</Grid>
				<ErrorModal
					onHide={() => setFetchDataError(null)}
					error={fetchDataError}
				/>
			</>
		);
	}
	return <></>;
};
